import { render } from "./CustomerList.vue?vue&type=template&id=03747ab2&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"

import "./CustomerList.vue?vue&type=style&index=0&id=03747ab2&scoped=true&lang=css"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03747ab2"]])

export default __exports__